import { BackgroundEffectsList } from 'components';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../MenuItem';

type BackgroundEffectsMenuProps = {
  className?: string;
};

export function BackgroundEffectsMenu({ className }: BackgroundEffectsMenuProps): JSX.Element {
  const { t } = useTranslation('providerRoom');

  return (
    <>
      <MenuItem title={t('menus.background')} className={className}>
        <BackgroundEffectsList />
      </MenuItem>
    </>
  );
}
